<template>
    <div class="bo-radio">
        <template>
            <label v-for="option in options" :key="option">
                <input type="radio" v-model="dataValue" :value="option" :disabled="disabled" />
                <span>
                    {{ getLabel(option) }}
                </span>
            </label>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: [Array, Object],
            default: () => {
                return [];
            },
        },
        labels: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },

    model: {
        prop: "value",
        event: "change",
    },

    computed: {
        dataValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
    },

    methods: {
        changeHandler(key) {
            this.dataValue = key;
        },
        getLabel(key) {
            return this.labels[key] ?? key;
        },
    },
};
</script>
